import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { Flex } from '@finect/tabular-core/Flex';
import { Button } from '@finect/tabular-core/Button';
export var Inner = styled.div.withConfig({
  displayName: "layout__Inner",
  componentId: "sc-1bozb10-0"
})(["display:block;"]);
export var EmptyResults = styled.div.withConfig({
  displayName: "layout__EmptyResults",
  componentId: "sc-1bozb10-1"
})(["text-align:center;p{max-width:100%;}"]);
export var FilterBlock = styled(Flex).withConfig({
  displayName: "layout__FilterBlock",
  componentId: "sc-1bozb10-2"
})(["display:flex;margin-bottom:16px;"]);
export var Filters = styled.div.withConfig({
  displayName: "layout__Filters",
  componentId: "sc-1bozb10-3"
})(["display:block;"]);
export var OrdersBy = styled.div.withConfig({
  displayName: "layout__OrdersBy",
  componentId: "sc-1bozb10-4"
})(["display:block;margin-left:auto;"]);
export var ContentBlock = styled.div.withConfig({
  displayName: "layout__ContentBlock",
  componentId: "sc-1bozb10-5"
})(["display:flex;flex-flow:column;", ";"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-flow: row;\n    justify-content: space-between;\n  "]))));
export var Aside = styled.div.withConfig({
  displayName: "layout__Aside",
  componentId: "sc-1bozb10-6"
})(["", ";", ";"], minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", "px;\n  "])), grid(3)), maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 1rem;\n  "]))));
export var Content = styled.div.withConfig({
  displayName: "layout__Content",
  componentId: "sc-1bozb10-7"
})(["", " ", ";"], function (props) {
  return props.centered && css(["display:flex;flex-flow:column;justify-content:center;"]);
}, minMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: ", "px;\n    margin-left: ", "px;\n  "])), grid(8), grid(1)));
export var MoreButton = styled(ButtonLined).withConfig({
  displayName: "layout__MoreButton",
  componentId: "sc-1bozb10-8"
})(["svg{margin-left:16px;vertical-align:middle;}"]);
export var ResetButton = styled(Button).withConfig({
  displayName: "layout__ResetButton",
  componentId: "sc-1bozb10-9"
})(["border:none;background:transparent;color:", ";transition:background-color 0.15s;&[disabled]{border:none;cursor:not-allowed;color:", ";}&:focus{box-shadow:none;}&:not([disabled]):hover{background-color:#fff;color:", ";}", ";"], function (_ref) {
  var theme = _ref.theme,
    secondary = _ref.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontLL;
}, function (_ref3) {
  var theme = _ref3.theme,
    secondary = _ref3.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
}, maxMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));